import { loadScript } from './loadScript';
import { Environment, LoadMicroAppOptions } from './types';

const REQUIRED_REACT_VERSION = [16, 13, 0];

// tslint:disable-next-line:no-any
function isRequiredReactVersion(React?: any, ReactDOM?: any) {
  if (!React || !ReactDOM || !ReactDOM.version) return false;

  const [reactMajor, reactMinor, reactPatch] = React.version.split('.').map(parseFloat);
  const [reactDomMajor, reactDomMinor, reactDomPatch] = ReactDOM.version.split('.').map(parseFloat);
  const [requiredMajor, requiredMinor, requiredPatch] = REQUIRED_REACT_VERSION;

  return (
    reactMajor >= requiredMajor &&
    reactMinor >= requiredMinor &&
    reactPatch >= requiredPatch &&
    reactDomMajor >= requiredMajor &&
    reactDomMinor >= requiredMinor &&
    reactDomPatch >= requiredPatch
  );
}

export function loadMicroApp({
  name,
  environment,
  jurisdiction,
  useVendors = true,
  useModernBuild = false,
  dependencies = {},
  attributes = {},
}: LoadMicroAppOptions): Promise<void[]> {
  const envPostfix = environment === Environment.PROD ? '' : `-${environment}`;
  const buildPostfix = useModernBuild && 'noModule' in HTMLScriptElement.prototype ? '.modern' : '';
  const vendorsUrl = `https://apps.static-cs.williamhill${envPostfix}.${jurisdiction}/${name}/vendors.js`;
  const bundleUrl = `https://apps.static-cs.williamhill${envPostfix}.${jurisdiction}/${name}/bundle${buildPostfix}.js`;

  const { React, ReactDOM, ...otherDependencies } = dependencies;
  const isHavingRequiredReactVersion = isRequiredReactVersion(React, ReactDOM);
  const isVendorsRequired = useVendors && !isHavingRequiredReactVersion;

  return Promise.all([
    ...(isVendorsRequired
      ? [
          loadScript({
            name: 'cp-cj-vendors',
            src: vendorsUrl,
            attributes: { crossorigin: 'anonymous', async: false },
          }),
        ]
      : []),
    loadScript({
      name: `cp-${name}`,
      src: bundleUrl,
      attributes: { ...attributes, crossorigin: 'anonymous', async: false },
      dependencies: Object.entries(
        isHavingRequiredReactVersion ? { React, ReactDOM, ...otherDependencies } : otherDependencies
      ).reduce((acc, [key, value]) => {
        acc[`WH.cp-deps.${key}`] = value;

        return acc;
      }, ({} as unknown) as Record<string, unknown>),
    }),
  ]);
}
